import React, { useEffect, useState, useCallback } from 'react';
import Card from '../../components/ui/Card';
import { Input, Select } from '../../components/ui/Input';
import { logAuditoriaApi, usuariosApi } from '../../api/admin';
import { COLORS } from '../../theme';
import { useTituloPagina } from '../../context/PageTitleContext';

const ACAO_LABEL = {
  'pedido.cancelar': 'Cancelar Pedido',
  'pedido.excluir': 'Excluir Pedido',
  'pedido.faturar': 'Faturar Pedido',
  'pedido.cancelar_faturamento': 'Cancelar Faturamento',
  'pedido.devolucao_cliente': 'Devolução de Mercadoria',
  'pedido.retornar_almoxarifado': 'Retornar ao Almoxarifado',
  'proposta.cancelar': 'Cancelar Proposta',
  'proposta.excluir': 'Excluir Proposta',
  'proposta.converter': 'Efetivar Proposta',
  'proposta.enviar_negociacao': 'Enviar para Negociação',
  'proposta.resolver_negociacao': 'Resolver Negociação',
  'meta.lancar_bonificacao': 'Lançar Bonificação de Meta',
  'meta.excluir': 'Excluir Meta'
};

const ENTIDADE_LABEL = { pedido: 'Pedido', proposta: 'Proposta', meta: 'Meta' };

const OPCOES_ACAO = [{ value: '', label: 'Todas as ações' }, ...Object.entries(ACAO_LABEL).map(([value, label]) => ({ value, label }))];
const OPCOES_ENTIDADE = [{ value: '', label: 'Todas' }, ...Object.entries(ENTIDADE_LABEL).map(([value, label]) => ({ value, label }))];

function resumoDetalhes(detalhesJson) {
  if (!detalhesJson) return '-';
  try {
    const obj = JSON.parse(detalhesJson);
    return Object.entries(obj).map(([k, v]) => `${k}: ${typeof v === 'object' ? JSON.stringify(v) : v}`).join(' · ');
  } catch (e) {
    return detalhesJson;
  }
}

export default function AuditoriaList() {
  useTituloPagina('Log de Auditoria');
  const [registros, setRegistros] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [usuarioId, setUsuarioId] = useState('');
  const [acao, setAcao] = useState('');
  const [entidade, setEntidade] = useState('');
  const [dataDe, setDataDe] = useState('');
  const [dataAte, setDataAte] = useState('');

  useEffect(() => { usuariosApi.listar().then(setUsuarios).catch(() => {}); }, []);

  const carregar = useCallback(() => {
    const params = {};
    if (usuarioId) params.usuario_id = usuarioId;
    if (acao) params.acao = acao;
    if (entidade) params.entidade = entidade;
    if (dataDe) params.data_de = dataDe;
    if (dataAte) params.data_ate = dataAte;
    logAuditoriaApi.listar(params).then(setRegistros).catch(() => {});
  }, [usuarioId, acao, entidade, dataDe, dataAte]);

  useEffect(() => { carregar(); }, [carregar]);

  const opcoesUsuarios = [{ value: '', label: 'Todos os usuários' }, ...usuarios.map(u => ({ value: String(u.id), label: u.nome }))];

  return (
    <div>
      <Card style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: 14, borderBottom: `1px solid ${COLORS.border}`, display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'end' }}>
          <Select label="Usuário" options={opcoesUsuarios} value={usuarioId} onChange={e => setUsuarioId(e.target.value)} style={{ width: 200 }} />
          <Select label="Ação" options={OPCOES_ACAO} value={acao} onChange={e => setAcao(e.target.value)} style={{ width: 220 }} />
          <Select label="Entidade" options={OPCOES_ENTIDADE} value={entidade} onChange={e => setEntidade(e.target.value)} style={{ width: 150 }} />
          <Input label="De" type="date" value={dataDe} onChange={e => setDataDe(e.target.value)} style={{ width: 150 }} />
          <Input label="Até" type="date" value={dataAte} onChange={e => setDataAte(e.target.value)} style={{ width: 150 }} />
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ textAlign: 'left', background: COLORS.bg }}>
                <th style={{ padding: 10 }}>Data/Hora</th>
                <th style={{ padding: 10 }}>Usuário</th>
                <th style={{ padding: 10 }}>Ação</th>
                <th style={{ padding: 10 }}>Entidade</th>
                <th style={{ padding: 10 }}>Detalhes</th>
              </tr>
            </thead>
            <tbody>
              {registros.map(r => (
                <tr key={r.id} style={{ borderTop: `1px solid ${COLORS.border}` }}>
                  <td style={{ padding: 10, whiteSpace: 'nowrap' }}>{new Date(r.criado_em).toLocaleString('pt-BR')}</td>
                  <td style={{ padding: 10 }}>{r.usuario_nome || <em style={{ color: COLORS.textMid }}>usuário removido</em>}</td>
                  <td style={{ padding: 10 }}>{ACAO_LABEL[r.acao] || r.acao}</td>
                  <td style={{ padding: 10 }}>{ENTIDADE_LABEL[r.entidade] || r.entidade}{r.entidade_id ? ` #${r.entidade_id}` : ''}</td>
                  <td style={{ padding: 10, fontSize: 12, color: COLORS.textMid }}>{resumoDetalhes(r.detalhes)}</td>
                </tr>
              ))}
              {registros.length === 0 && (
                <tr><td colSpan={5} style={{ padding: 20, textAlign: 'center', color: COLORS.textMid }}>Nenhum registro encontrado.</td></tr>
              )}
            </tbody>
          </table>
        </div>
        <div style={{ padding: '8px 14px', fontSize: 11, color: COLORS.textLight, borderTop: `1px solid ${COLORS.border}` }}>
          Mostrando os 500 registros mais recentes do período filtrado.
        </div>
      </Card>
    </div>
  );
}
